<div class="wrapper" *ngIf="mediaclip" [ngClass]="{'filter-visibility': filterVisibility,
	'in-modal': mode === 'in-modal', 'analytics-dashboard': mode === 'analytics-dashboard'}">
	<h2 [hidden]="['analytics-dashboard', 'in-modal'].includes(mode)">{{ 'CLIP' | translate }}: {{ mediaclip.title }}</h2>
	<div class="grid-container">
		<div class="top-block player-top-bar">
			<div class="show-interactivity-toggle" *ngIf="widgets?.length">
				<label class="label">
					<bb-check [(ngModel)]="highlightWidgets"></bb-check> {{ 'HIGHLIGHT_WIGETS' | translate }}
				</label>
			</div>
			<div class="right-aligned">
				<ng-container *ngIf="playerApiLoaded">
					<bb-button class="play-pause" *ngIf="playerApi" (click)="playPause()" [icon]="playerApi.isPlaying() ? 'pause' : 'play'">
						{{ (playerApi.isPlaying() ? 'PAUSE' : 'PLAY') | translate }}
					</bb-button>
				</ng-container>
			</div>
		</div>

		<div class="top-block picker-and-navigate" *ngIf="mode !== 'analytics-dashboard'">
			<bb-date-presets *ngIf="statsMinDate && !parentEntityId"
				[title]="'ANALYTICS_DATE_RANGE' | translate"
				(onChanged)="datesChanged($event)"
				[preset]="'last-6-months'"
				[icon]="'line-chart'"
				[minDate]="statsMinDate"
				[minDateWarning]="(!parentEntityId ? 'HELP.MEDIACLIP_STATS_DATE_CORRECTED' : 'HELP.PROJECT_STATS_DATE_CORRECTED') | translate: {date: (statsMinDate | date)}"
			>
				<a
					*ngIf="configuration && widgets?.length"
					[href]="getSheetDownloadUrl()"
					footer
					class="button download statistics"
				>
					<i class="fa fa-line-chart"></i>
					{{ 'DOWNLOAD_STATISTICS' | translate }}
				</a>
			</bb-date-presets>
			<bb-button *ngIf="parentEntityType === 'Project'" class="go-to-clip-button">
				<a
					(click)="navigatingAway(mediaclip?.id)"
					[routerLink]="[(mediaclip?.subusetype && mediaclip?.subusetype?.indexOf('vast_creative') > -1 ? '/adservices/vastservice/creatives/' : '/library/mediaclip/'), mediaclip?.id ]"
				>
					{{ 'GO_TO_CLIP_DETAILS' | translate }}
				</a>
			</bb-button>
		</div>

		<div class="block graph-block" *ngIf="mode !== 'analytics-dashboard'">
			<bb-tile
				sizing="r16-9"
				[headerBar]="true"
				[noData]="viewRangeNoData"
				[loading]="analyticsService.loadingData"
			>
				<span class="tile-title" *ngIf="!hideViews">
					<span class="stats top-right-values" *ngIf="analyticsService.metrics?.playerLoads?.count || analyticsService.metrics?.playerLoads?.count === 0">
						{{ 'PLAYER_LOADS' | translate }}
						<span class="stats-value"> {{ analyticsService.metrics?.playerLoads?.count | number }}</span>
					</span>
					<span class="stats">
						{{ 'VIEWS' | translate }}
						<strong class="title-value" *ngIf="views"> {{ views | number }}</strong>
					</span>
				</span>
				<bb-chart
					[bbChartSettings]="{
						maxTicksLimitX: 8,
						maxLabelRotation: 30
					}"
					[datasets]="viewRangeGraphDatasets"
					[responsiveSizing]="true"
					styling="analytics"
				></bb-chart>
				
			</bb-tile>
		</div>

		<div class="block player-container">
			<div class="player">
				<bb-player *ngIf="(mediaclip && ( mediaclip.mediatype === 'video' || mediaclip.mediatype === 'audio'))"
				 (onPlayerCreated)="playerCreated($event)" [mediaclip]="mediaclip" [autoplay]="true"
				 [playoutOverrides]="{autoPlay: mode !== 'analytics-dashboard' ? 'true' : 'false', autoMute: 'true', width: '100%', aspectRatio: '16:9',
				 responsiveSizing: 'true', allowImageSequence:'false', fullScreen: 'Hide', timeDisplay: 'Show progress and total time'}"></bb-player>

				<div *ngIf="mediaclip && mediaclip.mediatype === 'image'" [innerHTML]="mediaclip | thumbnail: 'preview' | async"></div>
			</div>
			<div class="player-timeline-overlay" *ngIf="widgets?.length && (highlightWidgets || (highLightWidget && highLightWidget.id))"
			 (mouseover)="true" [ngStyle]="playerOverlayStyling" [ngClass]="{'hover-mode':(highLightWidget && highLightWidget.id)}">

				<ng-container *ngFor="let widget of widgets">
					<div class="widget" (mouseover)="highLightWidget=widget" (mouseout)="highLightWidget={}" [ngStyle]="{
							position: 'absolute',
							top: getWidgetPropValue(widget, 'ypos'),
							left: getWidgetPropValue(widget, 'xpos'),
							width: widget.widgetdefinitiontype !== 'app' ? getWidgetPropValue(widget, 'width') : '100%',
							height: widget.widgetdefinitiontype !== 'app' ? getWidgetPropValue(widget, 'height') : '100%'
						}"
					 [ngClass]="{
							hovering: highLightWidget && highLightWidget.id == widget.id,
							'app-widget': widget.widgetdefinitiontype === 'app',
							'visible-now': widget.currentlyVisible
						}">
						<span class="widget-property icon" [innerHTML]="widget.widgetdefinitiontype | widgetIcon:widget.inApp"></span>
						<span class="widget-property label">{{ widget.label }}</span>
						<!-- widgets in app -->
						<div class="widget in-app" *ngFor="let subwidget of widget.widgets" [hidden]="subwidget.widgetdefinitiontype === 'app'"
						 (mouseover)="highLightWidget=subwidget;$event.stopPropagation()" (mouseout)="highLightWidget={}" [ngStyle]="{
								position: 'absolute',
								top: getWidgetPropValue(subwidget, 'ypos'),
								left: getWidgetPropValue(subwidget, 'xpos'),
								width: getWidgetPropValue(subwidget, 'width'),
								height: getWidgetPropValue(subwidget, 'height')
							}"
						 [ngClass]="{
								hovering: highLightWidget && highLightWidget.id == subwidget.id,
								'visible-now': subwidget.currentlyVisible
							}">
							<span class="widget-property icon" [innerHTML]="subwidget.widgetdefinitiontype | widgetIcon:subwidget.inApp:widget.label"></span>
							<span class="widget-property label">{{ subwidget.label }}</span>
						</div>
					</div>

				</ng-container>
			</div>
		</div>

		<div class="block widget-block">
			<div class="template-selector" [hasPublicationFieldOrPermission]="'playoutTemplateStats'">
				<bb-form-element [label]="'INTERACTIVE_TEMPLATE' | translate">
					<bb-entity-selector [entityType]="'app'" [(ngModel)]="templateId" name="templateId" (ngModelChange)="onTemplateIdChange($event)"></bb-entity-selector>
				</bb-form-element>
				<bb-form-element [label]="'TIMELINE_ID' | translate">
					<input type="text" [(ngModel)]="timelineId" name="timelineId" (change)="onTimelineIdChange($event)" />
				</bb-form-element>
			</div>
			<div *ngIf="parentEntityId && (!widgets || !widgets.length)">
				<p class="warning message"><i class="fa fa-warning"></i> {{ 'MEDIACLIP_NOT_IN_PROJECT_OR_NO_INTERACTIVE_ELEMENTS' |
					translate }}</p>
			</div>
			<div class="no-results" *ngIf="(templateId || timelineId) && !widgets?.length">
				<strong>
					{{ 'NO_WIDGETS_FOUND' | translate }}
				</strong>
			</div>
			<div class="no-results" *ngIf="(templateId || timelineId) && widgets?.length">
				<strong>
					{{ templateId && 'Template widgets' || timelineId && 'Timeline ' + timelineId + ' widgets' }}
				</strong>
			</div>
			<div *ngIf="widgets?.length" class="widgets">
				<div class="widget-list-container thin-scrollbar">
					<div class="message info" *ngIf="showFilterWarning">
						<i class="fa fa-warning"></i>
						{{ 'STATS_BELOW_ONLY_FILTERED_BY_DATERANGE' | translate }}
					</div>
					<bb-table-container *ngIf="widgets && widgets.length">

						<bb-table-header>
							<bb-table-header-cell>&nbsp;</bb-table-header-cell>
							<bb-table-header-cell>{{ 'LABEL' | translate }}</bb-table-header-cell>
							<bb-table-header-cell>{{ 'SHOWS' | translate }}</bb-table-header-cell>
							<bb-table-header-cell>{{ 'CLICKS' | translate }}</bb-table-header-cell>
							<bb-table-header-cell class="visibility-column"><label>{{ 'VISIBLE' | translate }} <bb-check class="small" theme="light2-theme"
										[(ngModel)]="filterVisibility"></bb-check></label></bb-table-header-cell>
							<bb-table-header-cell class="actions-column">{{ 'ACTIONS' | translate }}</bb-table-header-cell>
						</bb-table-header>

						<ng-container *ngFor="let widget of widgets">
							<bb-table-row *ngIf="!(filterVisibility && ( !widget.currentlyVisible && (!widget.parentWidget || !widget.parentWidget.currentlyVisible) ) )"
								class="widget-row" (mouseover)="highLightWidget=widget" (mouseout)="highLightWidget={}" [ngClass]="{
									hovering: highLightWidget && highLightWidget.id == widget.id,
									'visible-now': widget.inApp ? widget.parentWidget.currentlyVisible : widget.currentlyVisible}">
								<bb-table-cell class="widget-icon-cell"><span [innerHTML]="widget.widgetdefinitiontype | widgetIcon:widget.inApp"></span></bb-table-cell>
								<bb-table-cell>{{ widget.label }}</bb-table-cell>
								<bb-table-cell>{{ widget.stats.shows }}</bb-table-cell>
								<bb-table-cell>{{ widget.stats.clicks }} <span class="click-percentage" [hidden]="widget.stats.clicks === 0">(
										{{ ( widget.stats.shows === 0 ? 0 : (widget.stats.clicks / widget.stats.shows) ) | percentage:1 }} )</span></bb-table-cell>
								<bb-table-cell class="visibility-column">
									<span *ngIf="widget.ignoreTimelineShow === 'true'"><span [attr.title]="'SHOWN_PROGRAMMATICALLY' | translate"><i
												class="fa fa-cog"></i></span></span>
									<span *ngIf="widget.ignoreTimelineShow !== 'true'" class="widget-property inpoint in-out" (click)="seekToWidgetPoint(widget, 'in', widget.parentWidget)"><i
											class="fa fa-clock-o"></i> {{ widget.inpoint | number:'1.0-1' }}
											{{ widget.inpoint && (widget.inpoint | string).indexOf('%') != -1 ? '' : 's' }}
									</span> -
									<span *ngIf="widget.ignoreTimelineHide === 'true'"><span [attr.title]="'HIDDEN_PROGRAMMATICALLY' | translate"><i
												class="fa fa-cog"></i></span></span>
									<span *ngIf="widget.ignoreTimelineHide !== 'true'" class="widget-property outpoint in-out" (click)="seekToWidgetPoint(widget, 'out', widget.parentWidget)">
										{{ widget.outpoint | number:'1.0-1' }}
										{{ widget.outpoint && (widget.outpoint | string).indexOf('%') != -1 ? '' : 's' }}
									</span>
								</bb-table-cell>
								<bb-table-cell class="actions-column">

									<span *ngIf="widget?.onshow?.actions?.length">
										<span *ngFor="let action of widget.onshow.actions">
											<span [attr.title]="('ON_SHOW' | translate) + ': ' + action.action"><i class="fa fa-eye"></i></span>
										</span>
									</span>

									<span *ngIf="widget?.onmouseover?.actions?.length">
										<span *ngFor="let action of widget.onmouseover.actions">
											<span [attr.title]="('ON_MOUSE_OVER' | translate) + ': ' + action.action"><i class="fa fa-mouse-pointer"></i></span>
										</span>
									</span>

									<span *ngIf="widget?.onclick?.actions?.length">
										<span *ngFor="let action of widget.onclick.actions">
											<span [attr.title]="('ON_CLICK' | translate) + ': ' + action.action"><i class="fa fa-hand-pointer-o"></i></span>
										</span>
									</span>

									<span *ngIf="widget?.onmouseout?.actions?.length">
										<span *ngFor="let action of widget.onmouseout.actions">
											<span [attr.title]="('ON_MOUSE_OUT' | translate) + ': ' + action.action">
												<i class="fa fa-mouse-pointer"></i>
											</span>
										</span>
									</span>

									<span *ngIf="widget?.onhide?.actions?.length">
										<span *ngFor="let action of widget.onhide.actions">
											<span [attr.title]="('ON_HIDE' | translate) + ': ' + action.action"><i class="fa fa-eye-slash"></i></span>
										</span>
									</span>

									<span *ngIf="widget?.ontransitionDone?.actions?.length">
										<span *ngFor="let action of widget.ontransitionDone.actions">
											<span [attr.title]="('ON_TRANSITION_DONE' | translate) + ': ' + action.action"><i class="fa fa-fast-forward"></i></span>
										</span>
									</span>

								</bb-table-cell>
							</bb-table-row>
						</ng-container>
					</bb-table-container>


					<div *ngIf="filterVisibility && numVisibleWidgets === 0">
						<p>{{ 'NO_VISIBLE_INTERACTIVE_ELEMENTS' | translate }}</p>
					</div>
				</div>
			</div>
		</div>

		<div class="block dropoff-block">
			<!-- MEDIACLIP DETAILS: DROPOFF GRAPH -->
			<bb-tile class="mediaclip-details dropoff-tile"
				class="progress-chart-wrapper" [headerBar]="mode !== 'analytics-dashboard'"
				[noBorders]="mode === 'analytics-dashboard'"
				[noData]="!analyticsService.pctViewedGraphDatasets?.length"
				[loading]="analyticsService.loadingData">
				<span class="tile-title" *ngIf="mode !== 'analytics-dashboard'">
					{{ 'ENGAGEMENT' | translate }}
				</span>
				<div class="progress-chart-container">
					<bb-chart
						[style.position]="dropoffChartPosition"
						[bbChartSettings]="{
						maxTicksLimitX: 7,
						maxLabelRotation: 0,
						ticksCallbackX: ticksCallbackX,
						axisTypeX: 'linear'
					}" height="250" [datasets]="analyticsService.pctViewedGraphDatasets" styling="analytics"
						(chartAreaChange)="updateChartArea($event)" (click)="progressIndicatorClick($event)"></bb-chart>
					<bb-canvas-element #canvasElement (canvasContextChange)="updateCanvasContext($event)" height="250">
					</bb-canvas-element>
				</div>
			</bb-tile>
		</div>

	</div>
</div>
